import _objectWithoutProperties from "/home/runner/work/discretize.eu/discretize.eu/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/work/discretize.eu/discretize.eu/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["theme"];
var _root2, _root4, _pre;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import e from "react";
import { Paper as r, useTheme as t, useMediaQuery as a, Container as o, Box as i } from "@mui/material";
import { createTheme as n, ThemeProvider as d } from "@mui/material/styles";
import { withTheme as l } from "@mui/styles";
var s = {
    exports: {}
  },
  p = {},
  m = e,
  c = Symbol.for("react.element"),
  g = Symbol.for("react.fragment"),
  f = Object.prototype.hasOwnProperty,
  u = m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
  b = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };
function h(e, r, t) {
  var a,
    o = {},
    i = null,
    n = null;
  for (a in void 0 !== t && (i = "" + t), void 0 !== r.key && (i = "" + r.key), void 0 !== r.ref && (n = r.ref), r) {
    f.call(r, a) && !b.hasOwnProperty(a) && (o[a] = r[a]);
  }
  if (e && e.defaultProps) for (a in r = e.defaultProps) {
    void 0 === o[a] && (o[a] = r[a]);
  }
  return {
    $$typeof: c,
    type: e,
    key: i,
    ref: n,
    props: o,
    _owner: u.current
  };
}
p.Fragment = g, p.jsx = h, p.jsxs = h, s.exports = p;
var y = n({
  palette: {
    mode: "dark",
    primary: {
      main: "#00cccc",
      light: "#64ffff",
      dark: "#009a9b"
    },
    secondary: {
      main: "#ff6e40",
      light: "#FF8B66",
      dark: "#B24D2C"
    },
    embossed: "#2a2c31",
    background: {
      default: "#2f3136",
      paper: "#26292e"
    },
    text: {
      primary: "#ddd",
      secondary: "#b1b1b5"
    },
    divider: "#1e2124",
    star: "#FFDF00"
  },
  typography: {
    fontFamily: "Muli",
    fontSize: 16,
    h1: {
      fontFamily: "Raleway"
    },
    h2: {
      fontFamily: "Raleway"
    },
    h3: {
      fontFamily: "Raleway"
    },
    h4: {
      fontFamily: "Raleway"
    },
    h5: {
      fontFamily: "Raleway"
    },
    h6: {
      fontFamily: "Raleway"
    }
  }
});
var k = n(y, {
    components: {
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            marginBottom: "-2px !important"
          }
        }
      },
      MuiTable: {
        styleOverrides: {
          root: {
            marginBottom: y.spacing(2)
          }
        }
      },
      MuiTableHead: {
        styleOverrides: {
          root: _defineProperty({}, y.breakpoints.down("md"), {
            display: "block",
            width: "auto"
          })
        }
      },
      MuiTableBody: {
        styleOverrides: {
          root: (_root2 = {}, _defineProperty(_root2, y.breakpoints.down("md"), {
            display: "block",
            width: "auto"
          }), _defineProperty(_root2, "&> tr:last-child", {
            "&> th, td": {
              borderBottom: "none"
            }
          }), _root2)
        }
      },
      MuiTableRow: {
        styleOverrides: {
          root: _defineProperty({}, y.breakpoints.down("md"), {
            paddingTop: y.spacing(1),
            paddingBottom: y.spacing(1),
            display: "block",
            width: "auto",
            height: "auto",
            "&:not(:last-child)": {
              borderBottom: "1px solid ".concat(y.palette.divider)
            }
          }),
          head: _defineProperty({}, y.breakpoints.down("md"), {
            height: "auto",
            borderBottom: "1px solid ".concat(y.palette.divider)
          })
        }
      },
      MuiTableCell: {
        styleOverrides: {
          root: (_root4 = {
            borderBottom: "1px solid ".concat(y.palette.divider)
          }, _defineProperty(_root4, y.breakpoints.down("md"), {
            display: "block",
            width: "auto",
            borderBottom: "none",
            padding: "4px 24px 4px 24px"
          }), _defineProperty(_root4, "th&", {
            fontWeight: 700
          }), _defineProperty(_root4, "& > *:last-child", {
            marginBottom: 0
          }), _root4),
          head: {
            fontSize: "0.8571428571428571rem",
            color: y.palette.text.secondary,
            lineHeight: "inherit"
          }
        }
      },
      MuiButton: {
        styleOverrides: {
          contained: {
            fontWeight: 600,
            transition: y.transitions.create(["background-color", "box-shadow", "border", "color"], {
              duration: y.transitions.duration.short
            }),
            "&:hover": {
              color: "white !important"
            }
          }
        }
      },
      MuiButtonBase: {
        defaultProps: {
          disableRipple: !0
        }
      },
      MuiGridList: {
        styleOverrides: {
          root: {
            overflowY: "initial"
          }
        }
      },
      MuiGridListTile: {
        styleOverrides: {
          tile: {
            overflow: "initial"
          }
        }
      },
      MuiList: {
        styleOverrides: {
          root: {
            "& > hr": {
              marginBottom: 0
            }
          }
        }
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            paddingTop: "11px",
            paddingBottom: "11px",
            "& > *:first-child": {
              paddingLeft: 0
            }
          },
          dense: {
            paddingTop: "8px",
            paddingBottom: "8px"
          }
        }
      },
      MuiListItemText: {
        styleOverrides: {
          root: {
            marginTop: 0,
            marginBottom: 0,
            padding: "0 16px"
          }
        }
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            background: y.palette.background.paper
          }
        }
      },
      MuiMenu: {
        defaultProps: {
          elevation: 0
        }
      },
      MuiPaper: {
        defaultProps: {
          elevation: 0
        },
        styleOverrides: {
          root: {
            boxShadow: y.shadows[1]
          }
        }
      },
      MuiDivider: {
        styleOverrides: {
          root: {
            marginBottom: y.spacing(2)
          }
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          PaperComponent: function PaperComponent(_ref) {
            var e = _ref.children;
            return s.exports.jsx(r, {
              elevation: 3,
              sx: {
                background: y.palette.background.paper
              },
              children: e
            });
          }
        }
      }
    }
  }),
  w = {
    body: {
      cursor: "url('/images/cursors/default.png'), default"
    },
    "a, button, input, .MuiMenuItem-root, .MuiInput-root, .MuiSelect-root, .MuiFormControlLabel-label, .MuiButtonBase-root, .noUi-handle, .MuiSlider-root, .MuiChip-root, .MuiSvgIcon-root, .MuiAutocomplete-option": {
      cursor: "url('/images/cursors/green.png'), pointer !important"
    },
    "::selection": {
      backgroundColor: k.palette.primary.dark,
      color: k.palette.common.white
    },
    "code, pre, samp": {
      fontFamily: "Fira Mono",
      lineHeight: 1,
      fontSize: "0.875rem"
    },
    "code, samp": {
      color: k.palette.common.white,
      backgroundColor: k.palette.background.embossed,
      padding: "".concat(k.spacing(.25), " ").concat(k.spacing(.75)),
      border: "1px solid ".concat(k.palette.divider),
      borderRadius: k.shape.borderRadius,
      boxShadow: k.shadows[1]
    },
    pre: (_pre = {
      margin: "0 ".concat(k.spacing(2), " ").concat(k.spacing(2))
    }, _defineProperty(_pre, k.breakpoints.up("sm"), {
      marginLeft: k.spacing(3),
      marginRight: k.spacing(3)
    }), _defineProperty(_pre, "whiteSpace", "pre"), _defineProperty(_pre, "& > code", {
      padding: k.spacing(2),
      display: "block",
      width: "100%",
      boxShadow: k.shadows[2],
      wordWrap: "normal",
      wordBreak: "normal",
      whiteSpace: "pre",
      overflowX: "auto"
    }), _pre),
    blockquote: _defineProperty({
      borderLeft: "2px solid ".concat(k.palette.primary.main),
      padding: k.spacing(2),
      margin: "".concat(k.spacing(2), " ").concat(k.spacing(2))
    }, k.breakpoints.up("sm"), {
      marginLeft: k.spacing(3),
      marginRight: k.spacing(3)
    }),
    "::-webkit-scrollbar": {
      width: k.spacing(1),
      height: k.spacing(1)
    },
    "::-webkit-scrollbar-track": {
      background: "#1e2124"
    },
    "::-webkit-scrollbar-thumb": {
      background: "#484b51",
      borderRadius: k.shape.borderRadius
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#b1b1b5"
    },
    "::-webkit-scrollbar-corner": {
      background: "#1e2124"
    },
    "#nprogress .bar": {
      zIndex: 1501,
      height: 3
    }
  };
var v = {
  guardian: function guardian(e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      name: "guardian",
      palette: _objectSpread(_objectSpread({}, e.palette), {}, {
        primary: {
          light: "#a5f4ff",
          main: "#72c1d9",
          dark: "#3d91a7"
        }
      })
    });
  },
  revenant: function revenant(e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      name: "revenant",
      palette: _objectSpread(_objectSpread({}, e.palette), {}, {
        primary: {
          light: "#ff9e87",
          main: "#d16e5a",
          dark: "#9c4030"
        }
      })
    });
  },
  warrior: function warrior(e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      name: "warrior",
      palette: _objectSpread(_objectSpread({}, e.palette), {}, {
        primary: {
          light: "#ffff97",
          main: "#ffd166",
          dark: "#c9a036"
        }
      })
    });
  },
  engineer: function engineer(e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      name: "engineer",
      palette: _objectSpread(_objectSpread({}, e.palette), {}, {
        primary: {
          light: "#ffcd87",
          main: "#d09c59",
          dark: "#9c6e2d"
        }
      })
    });
  },
  ranger: function ranger(e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      name: "ranger",
      palette: _objectSpread(_objectSpread({}, e.palette), {}, {
        primary: {
          light: "#bfffb2",
          main: "#8CDC82",
          dark: "#5baa54"
        }
      })
    });
  },
  thief: function thief(e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      name: "thief",
      palette: _objectSpread(_objectSpread({}, e.palette), {}, {
        primary: {
          light: "#f3bfc5",
          main: "#c08f95",
          dark: "#8f6167"
        }
      })
    });
  },
  elementalist: function elementalist(e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      name: "elementalist",
      palette: _objectSpread(_objectSpread({}, e.palette), {}, {
        primary: {
          light: "#ffbbb7",
          main: "#f68a87",
          dark: "#c05b5a"
        }
      })
    });
  },
  mesmer: function mesmer(e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      name: "mesmer",
      palette: _objectSpread(_objectSpread({}, e.palette), {}, {
        primary: {
          light: "#e9a9ff",
          main: "#b679d5",
          dark: "#854ba3"
        }
      })
    });
  },
  necromancer: function necromancer(e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      name: "necromancer",
      palette: _objectSpread(_objectSpread({}, e.palette), {}, {
        primary: {
          light: "#83d99e",
          main: "#52a76f",
          dark: "#1d7743"
        }
      })
    });
  },
  boon: function boon(e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      name: "boon",
      palette: _objectSpread(_objectSpread({}, e.palette), {}, {
        primary: {
          light: "#ffebaa",
          main: "#e5b97a",
          dark: "#b1894d"
        }
      })
    });
  },
  condition: function condition(e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      name: "condition",
      palette: _objectSpread(_objectSpread({}, e.palette), {}, {
        primary: {
          light: "#ff6a5c",
          main: "#ea3131",
          dark: "#b00009"
        }
      })
    });
  },
  control: function control(e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      name: "control",
      palette: _objectSpread(_objectSpread({}, e.palette), {}, {
        primary: {
          light: "#ffffff",
          main: "#ecdfd7",
          dark: "#baada6"
        }
      })
    });
  },
  effect: function effect(e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      name: "effect",
      palette: _objectSpread(_objectSpread({}, e.palette), {}, {
        primary: {
          light: "#c8ffff",
          main: "#93ffec",
          dark: "#5ecbba"
        }
      })
    });
  }
};
var x = function x(_ref2) {
    var e = _ref2.children,
      r = _ref2.ContainerProps,
      _ref2$disableContaine = _ref2.disableContainer,
      n = _ref2$disableContaine === void 0 ? !1 : _ref2$disableContaine;
    var d = t(),
      l = a(d.breakpoints.down("lg"));
    return s.exports.jsx(s.exports.Fragment, {
      children: !n && !l && s.exports.jsx(o, _objectSpread(_objectSpread({
        maxWidth: "lg"
      }, r), {}, {
        children: s.exports.jsx(i, {
          sx: {
            padding: 2,
            backgroundColor: "background.default",
            boxShadow: 5
          },
          children: e
        })
      })) || s.exports.jsx(i, {
        p: 2,
        children: e
      })
    });
  },
  M = {
    dragonhunter: "guardian",
    firebrand: "guardian",
    willbender: "guardian",
    herald: "revenant",
    renegade: "revenant",
    vindicator: "revenant",
    berserker: "warrior",
    spellbreaker: "warrior",
    bladesworn: "warrior",
    scrapper: "engineer",
    holosmith: "engineer",
    mechanist: "engineer",
    druid: "ranger",
    soulbeast: "ranger",
    untamed: "ranger",
    daredevil: "thief",
    deadeye: "thief",
    specter: "thief",
    tempest: "elementalist",
    weaver: "elementalist",
    catalyst: "elementalist",
    chronomancer: "mesmer",
    mirage: "mesmer",
    virtuoso: "mesmer",
    reaper: "necromancer",
    scourge: "necromancer",
    harbinger: "necromancer"
  };
var B = function B(e) {
  return function (r) {
    return l(function (_ref3) {
      var t = _ref3.theme,
        a = _objectWithoutProperties(_ref3, _excluded);
      var _ref4 = e || _objectSpread({}, a),
        o = _ref4.profession,
        i = _ref4.specialization,
        n = _ref4.type;
      var l;
      if (l = o && "string" == typeof o && o.toLowerCase(), !l) {
        var _e = i && "string" == typeof i && i.toLowerCase();
        l = _e && (M[_e] || _e);
      }
      l || (l = n && "string" == typeof n && n.toLowerCase());
      var p = l && (!t || l !== t.name) && v[l];
      return p ? s.exports.jsx(d, {
        theme: p,
        children: s.exports.jsx(r, _objectSpread({}, a))
      }) : s.exports.jsx(r, _objectSpread({}, a));
    });
  };
};
export { x as Layout, w as globals, k as muiTheme, v as professionTheme, B as withGw2Theme };